export default __webpack_public_path__ + "static/media/security-check.e98f82eb.svg";